import { useInternational } from '@/common/locale';
import { MenuInfo } from '../types';
import { storeToRefs } from 'pinia';
import { useMyInfoStore } from '@/config/stores/my-info';

export interface Props {
  info: MenuInfo;
  selected?: boolean;
}

export interface Emit {
  (e: 'hover', evt: MouseEvent): void;
  (e: 'click', evt: MouseEvent): void;
}

export const setup = (emit: Emit) => {
  const { t } = useInternational();

  const { myInfo: userInfo } = storeToRefs(useMyInfoStore());

  const onHoverButton = (e: MouseEvent) => {
    emit('hover', e);
  };

  const onClickButton = (e: MouseEvent) => {
    emit('click', e);
  };

  return {
    t,
    userInfo,

    onHoverButton,
    onClickButton,
  };
};
